import React, {useEffect} from 'react';
import SignIn from '../Auth/SignIn'
import {setupChatroom} from '../../actions/ChatRoom'
import { useDispatch, useSelector } from 'react-redux';
import ChatInterface from './ChatInterface';


// ---------------------
// Component 
// ---------------------

const ChatRouter = ({room, isAdmin}) => {

    const dispatch = useDispatch();

    // Setup the Chat Room
    useEffect(() => { 
        // Set Up Chatroom
        dispatch(setupChatroom(room))
    }, []);

    // -----------------------
    // Authenticate
    // -----------------------

    const auth = useSelector(state => {
        if(!state.ChatRoom) return null;
        return state.ChatRoom.auth
    });

     // Not Authenticated
     if(!auth) return (<SignIn />);

    // Show Interface
    return (
        <ChatInterface room={room} isAdmin={isAdmin} auth={auth} />
    )

}

export default ChatRouter;
